export const style = {
  wrapper: {
    border: `1px solid #f8f8f8`
  },
  message: {
    // padding: `10px`,
    ':nth-of-type(even)': {
      // background: `#f8f8f8`
    }
  },
  info: {
    fontSize: `12px`
  },
  p: {
    maxWidth: `80%`,
    padding: `5px 0`
  },
  header: {
    // margin: 0,
    padding: `20px 25px`,
    paddingBottom: `15px`,
    background: `#f6f6f6`
  },
  reply: {
    padding: `10px 25px`,
    // marginTop: `2px`,
    background: `#f8f8f8`,
    borderRadius: `0 5px 5px 5px`
  },
  otherUser: {
    borderRadius: `5px 0 5px 5px`
  },
  authorSpan: {
    color: `#666`,
    fontSize: `13px`
  },
  actionsRow: {
    paddingTop: `15px`
  },
  actionsCol: {
    padding: `0 5px`,
    ':first-of-type': {
      paddingLeft: `15px`
    }
  },
  h3: {
    fontSize: `22px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Support/style/tickets.js